import template from './tasks.html';
import controller from './tasks.controller';

let tasksComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default tasksComponent;
